interface Translations {
    enUSTranslations: { [key: string]: string };
    enGBTranslations: { [key: string]: string };
    enAUTranslations: { [key: string]: string };
    esESTranslations: { [key: string]: string };
    frCATranslations: { [key: string]: string };
    frFRTranslations: { [key: string]: string };
}
export * from './consumer-login.component/consumer-login.component';
export * from './consumer-login.module';

import * as enUSTranslations from '../assets/en-US.json';
import * as enGBTranslations from '../assets/en-GB.json';
import * as enAUTranslations from '../assets/en-AU.json';
import * as esESTranslations from '../assets/es-ES.json';
import * as frCATranslations from '../assets/fr-CA.json';
import * as frFRTranslations from '../assets/fr-FR.json';
export const ConsumerLoginLanguage: Translations = { enUSTranslations, enGBTranslations, enAUTranslations, esESTranslations, frCATranslations, frFRTranslations };
export * from './consumer-redirection/customer-selection.component';
export * from './validators/app.validators';
export * from './models';
